import React from 'react';
import { Sparkles, Loader2 } from 'lucide-react';

const LoadingSpinner = ({ 
  size = 'md', 
  variant = 'default',
  text = '',
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-12 h-12'
  };

  const textSizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
    xl: 'text-lg'
  };

  if (variant === 'dots') {
    return (
      <div className={`flex items-center justify-center space-x-1 ${className}`}>
        <div className="typing-dots">
          <div className="typing-dot"></div>
          <div className="typing-dot"></div>
          <div className="typing-dot"></div>
        </div>
        {text && (
          <span className={`ml-2 text-arc-text-secondary ${textSizeClasses[size]}`}>
            {text}
          </span>
        )}
      </div>
    );
  }

  if (variant === 'pulse') {
    return (
      <div className={`flex items-center justify-center space-x-3 ${className}`}>
        <div className={`
          ${sizeClasses[size]} 
          bg-gradient-to-br from-arc-accent-primary to-arc-accent-secondary 
          rounded-full animate-pulse-subtle
        `}>
          <Sparkles className="w-full h-full text-white p-1" />
        </div>
        {text && (
          <span className={`text-arc-text-secondary ${textSizeClasses[size]}`}>
            {text}
          </span>
        )}
      </div>
    );
  }

  if (variant === 'minimal') {
    return (
      <div className={`inline-flex items-center space-x-2 ${className}`}>
        <div className={`
          ${sizeClasses[size]} 
          border-2 border-arc-border border-t-arc-accent-primary 
          rounded-full animate-spin
        `}></div>
        {text && (
          <span className={`text-arc-text-secondary ${textSizeClasses[size]}`}>
            {text}
          </span>
        )}
      </div>
    );
  }

  // Default variant
  return (
    <div className={`flex flex-col items-center justify-center space-y-3 ${className}`}>
      <div className="relative">
        {/* Outer ring */}
        <div className={`
          ${sizeClasses[size]} 
          border-4 border-arc-border rounded-full
        `}></div>
        
        {/* Inner spinning ring */}
        <div className={`
          absolute inset-0 ${sizeClasses[size]} 
          border-4 border-arc-accent-primary border-t-transparent 
          rounded-full animate-spin
        `}></div>
      </div>
      
      {text && (
        <div className="text-center">
          <p className={`text-arc-text-secondary ${textSizeClasses[size]} font-medium`}>
            {text}
          </p>
        </div>
      )}
    </div>
  );
};

// Preset variants for common use cases
export const PageLoader = ({ text = "Chargement..." }) => (
  <div className="flex items-center justify-center min-h-[200px]">
    <LoadingSpinner size="lg" text={text} />
  </div>
);

export const ButtonLoader = ({ text = "" }) => (
  <LoadingSpinner size="sm" variant="minimal" text={text} />
);

export const InlineLoader = ({ text = "" }) => (
  <LoadingSpinner size="sm" variant="dots" text={text} />
);

export const FullPageLoader = ({ text = "Chargement de l'application..." }) => (
  <div className="fixed inset-0 bg-arc-background flex items-center justify-center z-50">
    <div className="text-center space-y-4">
      <div className="relative w-16 h-16 mx-auto">
        <div className="absolute inset-0 border-4 border-arc-border rounded-full"></div>
        <div className="absolute inset-0 border-4 border-arc-accent-primary border-t-transparent rounded-full animate-spin"></div>
      </div>
      <div className="space-y-2">
        <h3 className="text-arc-text-primary font-semibold">Chat Consult</h3>
        <p className="text-sm text-arc-text-secondary">{text}</p>
      </div>
    </div>
  </div>
);

export default LoadingSpinner;